import { Typography } from '@mui/material';
import React, { FC } from 'react';

type Props = {
  error: { message: string } | null;
};

const ErrorMessage: FC<Props> = ({ error }: Props) => {
  return error ? (
    <Typography variant="inherit" component="p" color="error">
      {error.message}
    </Typography>
  ) : null;
};

export { ErrorMessage };
